"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Correspond to the 'usageType' property defined in devicePairing in the device service
 * services.lifesize_device/devicePairing/src/deviceConstants.ts
 */
var DeviceUsageTypes;
(function (DeviceUsageTypes) {
    DeviceUsageTypes["PERSONAL"] = "PERSONAL";
    DeviceUsageTypes["SHARED"] = "SHARED";
})(DeviceUsageTypes = exports.DeviceUsageTypes || (exports.DeviceUsageTypes = {}));
/**
 * Correspond to the 'pairingStatus' property defined in devicePairingStatus in the device service
 * services.lifesize_device/devicePairing/src/devicePairingStatus/devicePairingStatus.ts
 */
var DevicePairingStatusTypes;
(function (DevicePairingStatusTypes) {
    DevicePairingStatusTypes["BLOCKED"] = "BLOCKED";
    DevicePairingStatusTypes["COMPLETE"] = "COMPLETE";
    DevicePairingStatusTypes["DEFAULT"] = "DEFAULT";
    DevicePairingStatusTypes["DELETED"] = "DELETED";
    DevicePairingStatusTypes["NEW"] = "NEW";
})(DevicePairingStatusTypes = exports.DevicePairingStatusTypes || (exports.DevicePairingStatusTypes = {}));
